import { toast } from "@grafit/design-system/components/molecules/toast";
import type { TFunction } from "@grafit/i18n";
import { alertDevs } from "@grafit/shared/observability/sentry-front";
import { isApiReachable } from "./is-api-reachable";

export async function reportTenantConfigFailure(error: unknown, t: TFunction): Promise<void> {
  if (!(await isApiReachable())) {
    toast.error(t((r) => r["auth.sign-in.error.offline"]));
    return;
  }

  toast.error(t((r) => r["auth.sign-in.error.sso-unavailable"]));
  alertDevs({
    error: new Error("Failed to get SSO provider ID"),
    context: { error },
  });
}
